import React from "react";
import './SecurityInternship.css';
import TestimonialCarousel from './TestimonialCarousel';

function SecurityInternship() {
    return (
        <>
            <div className="security-main-container">
                {/* section 1  */}
                <div className="security-intro-container">
                    <div className="security-intro-wrap">
                        <div className="security-intro-row">
                            <div className="security-intro-box box1">
                                <h2>Security Internship Program</h2>
                                <p>Security Internship is a flagship program of Accenture Security-India to build the future talent workforce in the cybersecurity domain. This initiative is launched with a two-fold objective to meet the ATCI Security growth projections and to align ourselves with the org-level strategy  of a”create” talent mindset over a “consume” talent mind-set. Through the collaborative efforts of ATCI Security Delivery, Campus Recruitment, Human Resources and the LKM team, the interns are made industry ready by the end of the internship journey.
                                </p>
                            </div>
                            <div className="security-intro-box box2">
                                <img src="images/SecurityInternship/About-image.png" alt="about-img" className="security-intro-img" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* section 2  */}
                <div className="features-container">
                    <div className="features-wrap">
                        <h2>Program Features</h2>
                        <div className="features-row">
                            <div className="features-box">
                                <img src="images/SecurityInternship/feature1.png" alt="Feature-img" />
                                <div className="purpelBG"><p>B.Tech & M.Tech students pursuing their final semester Onboards</p></div>
                            </div>
                            <div className="features-box">
                                <img src="images/SecurityInternship/feature2.png" alt="Feature-img" />
                                <div className="purpelBG"><p>Curriculum covering Security Primer Fundamentals and Security Specializations</p></div>
                            </div>
                            <div className="features-box">
                                <img src="images/SecurityInternship/feature3.png" alt="Feature-img" />
                                <div className="purpelBG"><p>Training model: Blended: VILT+ Online guided labs+ Self –paced learnings+ SME connects+ Post assessment on onboarding</p></div>
                            </div>
                            <div className="features-box">
                                <img src="images/SecurityInternship/feature5.png" alt="Feature-img" />
                                <div className="purpelBG"><p>Project-based learnings</p></div>
                            </div>
                        </div>
                        <div className="features-row">

                            <div className="features-box">
                                <img src="images/SecurityInternship/feature6.png" alt="Feature-img" />
                                <div className="purpelBG"><p>Buddy support for all interns</p></div>
                            </div>
                            <div className="features-box">
                                <img src="images/SecurityInternship/feature7.png" alt="Feature-img" />
                                <div className="purpelBG"><p>Engagement Connects</p></div>
                            </div>
                            <div className="features-box">
                                <img src="images/SecurityInternship/feature8.png" alt="Feature-img" />
                                <div className="purpelBG"><p>Wellness and Mindfulness sessions</p></div>
                            </div>
                             <div className="features-box">
                                {/* <img src="images/SecurityInternship/feature4.png" alt="Feature-img" /> */}
                                {/* <div className="purpelBG"><p>B.Tech & M.Tech students pursuing their final semester Onboards</p></div> */}
                            </div> 
                        </div>
                    </div>
                </div>

                {/* section 3  */}
                <div className="internship-journey-container">
                    <div className="internship-journey-wrap">
                        <h2>Internship Journey</h2>
                        <div className="internship-journey-row">
                            <img src="images/SecurityInternship/Internship-Journey.png" alt="Intership-jouney-flow" />
                        </div>
                        <div className="internship-journey-row">
                            <div className="internship-journey-box">
                                <p>Campus Engagement Team</p>
                                <p>Leadership, HR, LKM, Campus Team</p>
                                <p>LKM/SME's</p>
                                <p>Buddy/Project Lead</p>
                                <p>Business Sponsor, HR, Campus, LKM</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* section 4  */}
                <div className="key-benefits-container">
                    <div className="key-benefits-wrap">
                        <h2>Key Benefits  for Interns</h2>
                        <div className="key-benefits-row">
                            <img src="images/SecurityInternship/Key-Benefits.png" alt="Intership-jouney-flow" />
                        </div>
                    </div>
                </div>

                {/* section 5 */}
                <div className="testimonial-container">
                    <div className="testimonial-wrap">
                        <h2>Testimonials</h2>
                        <TestimonialCarousel />
                    </div>
                </div>
                {/* section 6 */}
                <div className="image-container">
                    <img src="images/SecurityInternship/funteam_img.png" className="fun_team_image" alt="Fun-team" />
                </div>
            </div>
        </>
    );
}

export default SecurityInternship;